import React, { useState, useContext } from "react";
import { useAuth } from "../context/auth";
import { Redirect } from "react-router-dom";
import { store } from "../context/store.js";
import { JWT } from "../constants/local-storage";
import { functions } from "../constants/common-functions";
import { CHANGE_LOGGED_IN } from "../constants/action-types";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

import omniScanLogo from "../images/omniscanlogo.png";

export default function SystemLogin({ onSuccess }) {
  const [loggedIn, setLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [invalidCredentials, setInvalidCredentials] = useState(false);
  const [loading, setLoading] = useState(false);
  const [textFieldsDisabled, setTextFieldsDisabled] = useState(false);

  const { setAuthTokens } = useAuth();
  const globalState = useContext(store);
  const { dispatch } = globalState;

  const handleChangeUserName = (e) => setUserName(e.target.value);
  const handleChangePassword = (e) => setPassword(e.target.value);

  function postLogin() {
    setLoading(true);
    setTextFieldsDisabled(true);

    const user = { username: userName, password: password };
    const thisUrl = "/resolutionsoftwareplatform/login";

    fetch(thisUrl, {
      credentials: "include",
      method: "POST",
      body: JSON.stringify(user),
    })
      .then((result) => {
        if (result.status === 200) {
          let jwtToken = result.headers.get("Authorization");
          setAuthTokens(jwtToken);
          functions.getUser(setUser);

          // call parent success if provided (modal case)
          if (onSuccess) {
            onSuccess();
          } else {
            setLoggedIn(true);
          }
        } else {
          console.log(result);
          setInvalidCredentials(true);
          setLoading(false);
          setTextFieldsDisabled(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setInvalidCredentials(true);
        setLoading(false);
        setTextFieldsDisabled(false);
      });
  }

  const setUser = (user) => {
    dispatch({ type: CHANGE_LOGGED_IN, value: user });
  };

  // keep old redirect for full-page login
  if (loggedIn && !onSuccess) {
    return <Redirect to="/home" />;
  }

  const onKeyUp = (e) => {
    if (e.charCode === 13) {
      postLogin();
    }
  };

  const loginContent = {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    padding: "20px",
    width: "300px",
    height: "380px",
    backgroundColor: "#FFF",
    borderRadius: "6px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    alignSelf: "center",
  };

  const loginTextfield = {
    display: "flex",
    width: "auto",
    borderRadius: "3px",
    padding: "10px",
    border: "2px solid white",
  };

  const invalidCredentialsContainer = {
    display: invalidCredentials ? "flex" : "none",
    color: "#ff0000",
    borderRadius: "3px",
    minHeight: "40px",
    fontSize: "12px",
    fontFamily: "helvetica",
    alignSelf: "center",
  };

  const loginButton = {
    height: "45px",
    maxHeight: "45px",
    marginBottom: "15px",
    color: "#ffffff",
    backgroundColor: "#000",
  };

  const spinnerContainer = {
    display: "flex",
    width: "100%",
    height: "auto",
    alignItems: "center",
    justifyContent: "space-around",
    color: "#fff",
  };

  return (
    <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
      <div style={loginContent}>
        <img
          src={omniScanLogo}
          style={{ width: "180px", marginBottom: "20px", alignSelf: "center" }}
          alt="OmniScan company logo"
        />
        <TextField
          placeholder="Username"
          onChange={handleChangeUserName}
          style={loginTextfield}
          value={userName}
          disabled={textFieldsDisabled}
        />
        <TextField
          type="password"
          placeholder="Password"
          onChange={handleChangePassword}
          style={loginTextfield}
          value={password}
          disabled={textFieldsDisabled}
          onKeyPress={onKeyUp}
        />

        <Button
          variant="contained"
          color="primary"
          disabled={loading}
          onClick={postLogin}
          style={loginButton}
        >
          {loading ? (
            <div style={spinnerContainer}>
              <CircularProgress color="inherit" size={25} />
            </div>
          ) : (
            "LOGIN"
          )}
        </Button>

        <div style={invalidCredentialsContainer}>
          Invalid Username and/or password
        </div>
      </div>
    </div>
  );
}
